@if (balance && !settlesByInvoice) {
  <div class="not-applicable-notice" data-testid="ledger-not-applicable">
    <strong>No receivable for this organization.</strong>
    Causable collects this game's fees directly at the time of payment, so the organization never holds
    them and has nothing to remit. The fees earned below are shown for reference only.
  </div>
}

@if (balance) {
  <div class="balance-row">
    <mat-card class="balance-card">
      <mat-card-header>
        <mat-card-title>Fees Earned</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <span class="balance-amount" data-testid="causable-fees-earned">{{ balance.TotalCausableFeesEarned | formatCurrency }}</span>
        <p class="balance-hint">
          Causable fees + HST, excluding payments that were refunded or charged back
        </p>
      </mat-card-content>
    </mat-card>

    <mat-card class="balance-card">
      <mat-card-header>
        <mat-card-title>Remitted</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <span class="balance-amount" data-testid="causable-total-paid">{{ balance.TotalPaid | formatCurrency }}</span>
        <p class="balance-hint">Non-voided remittances received from the organization</p>
      </mat-card-content>
    </mat-card>

    @if (settlesByInvoice) {
      <mat-card class="balance-card" [class.credit]="isInCredit">
        <mat-card-header>
          <mat-card-title>{{ owedLabel }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <span class="balance-amount owed" data-testid="causable-amount-owed">{{ owedDisplayAmount | formatCurrency }}</span>
          <p class="balance-hint">
            @if (isInCredit) {
              The organization has over-remitted — Causable holds this credit
            } @else {
              Earned − remitted
            }
          </p>
        </mat-card-content>
      </mat-card>
    }
  </div>
}

@if (uiState === UIStateEnum.ShowLoading) {
  <app-loading-card-content></app-loading-card-content>
}

@if (settlesByInvoice) {
<mat-card class="record-card">
  <mat-card-header>
    <mat-card-title>Record a Remittance</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="remittanceForm" (ngSubmit)="onSubmit()">
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Amount ($)</mat-label>
          <input matInput
                 type="text"
                 inputmode="decimal"
                 data-testid="remittance-amount-input"
                 formControlName="amount"
                 (input)="sanitizeCurrencyInput($event)">
          @if (remittanceForm.get('amount')?.touched && remittanceForm.get('amount')?.invalid) {
            <mat-error>Enter an amount greater than $0.00</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Payment Date</mat-label>
          <input matInput type="date" data-testid="remittance-date-input" formControlName="paymentDate">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Reference # (cheque / EFT / wire)</mat-label>
          <input matInput type="text" data-testid="remittance-reference-input" formControlName="referenceNumber">
        </mat-form-field>
      </div>

      <div class="form-actions">
        @if (balance && balance.AmountOwed > 0) {
          <button mat-stroked-button type="button" data-testid="fill-full-amount-button" (click)="fillFullAmountOwed()">
            Fill full amount owed
          </button>
        }
        <button mat-flat-button
                color="primary"
                type="submit"
                data-testid="record-remittance-button"
                [disabled]="remittanceForm.invalid || isSubmitting">
          Record Remittance
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
}

<h3 class="payments-heading">Remittance History</h3>

<app-table-export-buttons
  testIdPrefix="causable-payments"
  [disabled]="uiState === UIStateEnum.ShowLoading"
  (exportCsv)="onExportCsv()"
  (exportPdf)="onExportPdf()">
</app-table-export-buttons>

<ag-grid-angular
  class="ag-theme-quartz"
  domLayout="autoHeight"
  data-testid="causable-payments-table"
  [tooltipShowDelay]="0"
  [loading]="uiState == UIStateEnum.ShowLoading"
  overlayNoRowsTemplate="<span>No remittances recorded for this organization</span>"
  (gridReady)="onPaymentsGridReady($event)"
  [rowData]="payments"
  [columnDefs]="paymentColDefs">
</ag-grid-angular>
